module.exports = __webpack_public_path__ + "static/Pheal-Logo-Black-ee0b8bd9453a66bb6419984e129133d5.png";